import react, { Component } from 'react';
import { connect } from "react-redux";
import { setAudioSounds } from '../actions/audio';


class AudioContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			audioFiles: [
				// {url: 'assets/media/intro_theme_long.mp3', name: 'intro_theme'},
				{url: 'assets/media/lose.mp3', name: 'lose'},
				// {url: 'assets/media/wager.mp3', name: 'wager'},
				{url: 'assets/media/game.mp3', name: 'game'},
				// {url: 'assets/media/top_bottom_word_animate.mp3', name: 'top_bottom'},
				{url: 'assets/media/correct.mp3', name: 'correct'},
				{url: 'assets/media/incorrect.mp3', name: 'incorrect'},
				// {url: 'assets/media/departure.mp3', name: 'departure'},
				// {url: 'assets/media/last_letter.mp3', name: 'last_letter'},
				// {url: 'assets/media/last_word.mp3', name: 'last_word'},
				{url: 'assets/media/rules.mp3', name: 'rules'},
				{url: 'assets/media/winning.mp3', name: 'winning'},
			]
		};
	}

	componentDidMount() {
		const audioFiles = this.state.audioFiles.map(file=>{
			return Object.assign({}, file, {audioObj: new Audio(file.url)});
		});

		this.props.setAudioSounds(audioFiles);
	}

	componentDidUpdate(prevState, prevProps) {

		if (this.props.sounds !== [] && prevProps.sounds !== this.props.sounds) {
			window.sounds = this.props.sounds;
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = state => ({
	sounds: state.audio.sounds
});

const mapDispatchToProps = dispatch => ({
  setAudioSounds: data => {
	  dispatch(setAudioSounds(data));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioContainer);
